import { faAngleDown, faCircleNodes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { IClusterInfo, IConstellationInfo } from "../../../../model/CarbonExternalModels";
import { AppSliceActions } from "../../../../store/app/appSlice";
import { useCarbonDispatch } from "../../../../store/carbonStore";
import { Button } from "userful-chronos-common-ui/dist";

interface IProps {
    foundObject: { cluster: IClusterInfo; constellation: IConstellationInfo };
}

export default function ClustersDropdown({ foundObject }: IProps) {
    const dispatch = useCarbonDispatch();

    const allClusters: IClusterInfo[] = foundObject.constellation.cluster;

    return (
        <Dropdown>
            <Dropdown.Toggle as={Button} bsPrefix="dropdownButtonSwitch" id="dropdownToggle">
                <div className="textInside">{foundObject.cluster.name}</div>
                <FontAwesomeIcon icon={faAngleDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="dropdownMenuSwitch"
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {allClusters.length > 1 && (
                    <>
                        {allClusters.map((c) => {
                            if (c.id.value !== foundObject.cluster.id.value) {
                                return (
                                    <Dropdown.Item
                                        key={c.id.value}
                                        className="dropdownItem"
                                        onClick={() => {
                                            dispatch(
                                                AppSliceActions.setAppView({
                                                    type: "CLUSTER",
                                                    id: c.id,
                                                }),
                                            );
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCircleNodes} />
                                        <div className="textInside">{c.name}</div>
                                    </Dropdown.Item>
                                );
                            }
                            return null;
                        })}
                    </>
                )}
                {allClusters.length === 1 && (
                    <Dropdown.Item className="dropdownItem" disabled>
                        <FontAwesomeIcon icon={faCircleNodes} />
                        <div className="textInside">No other clusters</div>
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
